import { useMediaQuery, useTheme } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Edit,
  EditProps,
  required,
  SaveButton,
  SelectInput,
  ShowButton,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { NotificationConditionalContentDto } from '../../../core/dto/system-notifications/notification-conditional-content.dto'
import { jsonStatusPropertyComparisonTypes } from '../../../core/enum/jsonStatusPropertyComparisonTypes'
import FilteredReferenceInput from '../../common/FilteredReferenceInput'
import { ResourceName } from '../../../core/ResourceName'
import { useHasAuthority } from '../../hooks/useHasAuthority'
import { NotificationCategoryDto } from '../../../core/dto/system-notifications/notification-category.dto'
import { Authority } from '../../../core/auth/Authority'

const validateNotificationConditionalContentEdit = (
  values: NotificationConditionalContentDto,
) => {
  const errors: { [n: string]: string } = {}
  if (!values.description) {
    errors.description = 'ra.validation.required'
  }
  if (!values.jsonStatusPropertyPath) {
    errors.jsonStatusPropertyPath = 'ra.validation.required'
  }
  if (!values.jsonStatusPropertyComparisonType) {
    errors.jsonStatusPropertyComparisonType = 'ra.validation.required'
  }
  if (!values.comparisonValue) {
    errors.comparisonValue = 'ra.validation.required'
  }
  if (!values.notificationCategoryId) {
    errors.notificationCategoryId = 'ra.validation.required'
  }
  return errors
}

const EditTitle = () => {
  const translate = useTranslate()
  return (
    <span>
      {translate('resources.notification-conditional-contents.titles.edit')}
    </span>
  )
}

const EditToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ShowButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const NotificationConditionalContentEdit = (props: EditProps) => {
  const hasAuthority = useHasAuthority()
  const theme = useTheme()
  const translate = useTranslate()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Edit {...props} hasShow={false} title={<EditTitle />}>
      <SimpleForm
        redirect="show"
        validate={validateNotificationConditionalContentEdit}
        toolbar={<EditToolbar />}
      >
        <TextField label="ID" source="id" />
        <TextInput source="description" isRequired />
        <TextInput source="jsonStatusPropertyPath" isRequired />
        <SelectInput
          source="jsonStatusPropertyComparisonType"
          choices={Object.keys(jsonStatusPropertyComparisonTypes).map(
            (key: string) => ({
              id: key,
              name: translate(
                `resources.enums.jsonStatusPropertyComparisonTypes.${key}`,
              ),
            }),
          )}
          validate={required()}
        />
        <TextInput source="comparisonValue" isRequired />
        {hasAuthority(Authority.VIEW_NOTIFICATION_TAGS) && (
          <FilteredReferenceInput
            source="notificationCategoryId"
            defaultValue={null}
            reference={ResourceName.NOTIFICATION_CATEGORIES}
            sort={{ field: 'id', order: 'ASC' }}
            perPage={smallScreen ? 5 : 15}
            filterSource="search"
            selectWithPaginationInputProps={{
              optionText: (choice: NotificationCategoryDto) =>
                `${choice.defaultTitle}`,
              showFilter: true,
            }}
            isRequired
          />
        )}
      </SimpleForm>
    </Edit>
  )
}
